import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "#FFF",
      d: "M6.7 6.9H.5v9.3h6.2l6.2 5.7V1.2zm10.3.9 7.6 7.6m0-7.6L17 15.4"
    }, null, -1)
  ]))]))
}
export default { render: render }